import { render, staticRenderFns } from "./set-thirds.vue?vue&type=template&id=655b00a8&scoped=true&"
import script from "./set-thirds.vue?vue&type=script&lang=js&"
export * from "./set-thirds.vue?vue&type=script&lang=js&"
import style0 from "./set-thirds.vue?vue&type=style&index=0&id=655b00a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b00a8",
  null
  
)

export default component.exports